<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="100"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="editById(row.LinkId)">编辑</el-button>
          <!-- <el-button size="mini" type="text" icon="el-icon-delete" @click="del(row)" /> -->
        </template>
      </el-table-column>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/website/link/list";
import editDialog from "@/components/website/link/editDialog";

export default {
  name: "booktag",
  mixins: [curdMixins],
  components: {
    list,
    editDialog
  },
  methods: {
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.LinkId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    }
  },
};
</script>